import React, { Component } from 'react';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core';

import Grid from '@material-ui/core/Grid';

const styles = theme => ({
  logo: {
    width: '90px',
    maxHeight: '50px'
  }
});

class Properties extends Component {

  render() {
    const publicDir = window.globals ? window.globals.gidPublic : '';

    return (
      <Grid container spacing={4} justify="center" alignContent="center" alignItems="center">

      </Grid>
    );
  }
}

const ConnectedProperties = connect()(Properties);

export default withStyles(styles)(ConnectedProperties);
